export enum TipoSocio {
    ActivoGeneral = "1",
    ProtectorGeneral = "2",
    ProtectorEstudiosContables = "10002",
    EstudiosContables = "10003",
    ProtectorBancos = "10004",
    ProtectorJubilado = "20002",
    SocioHonorario = "20003",
    ActivoGeneralGrupoComercial = "20004",
    SocioAdherente = "20005",
    ProtectorAdherenteA = "20006",
    ProtectorAdherenteB = "20007",
    ProtectorEcommerce = "20008"
}

export const TipoSocioNombre: Record<TipoSocio, string> = {
    [TipoSocio.ActivoGeneral]: 'Activo General',
    [TipoSocio.ProtectorGeneral]: 'Protector General',
    [TipoSocio.ProtectorEstudiosContables]: 'Protector (Estudios Contables)',
    [TipoSocio.EstudiosContables]: 'Estudios Contables',
    [TipoSocio.ProtectorBancos]: 'Protector (Bancos)',
    [TipoSocio.ProtectorJubilado]: 'Protector (Jubilado)',
    [TipoSocio.SocioHonorario]: 'Socio Honorario',
    [TipoSocio.ActivoGeneralGrupoComercial]: 'Activo General (tipo grupo comercial)',
    [TipoSocio.SocioAdherente]: 'Socio Adherente',
    [TipoSocio.ProtectorAdherenteA]: 'Protector Adherente A',
    [TipoSocio.ProtectorAdherenteB]: 'Protector Adherente B',
    [TipoSocio.ProtectorEcommerce]: 'Protector Ecommerce'
};
  

export function getNombreTipoSocio(id: string): string {
    return TipoSocioNombre[id as TipoSocio] || 'Desconocido';
}
  